import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isBrowser } from '@/utils/runtime';

const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Only scroll on client side
    if (isBrowser) {
      globalThis.scrollTo(0, 0);
    }
  }, [location.pathname]);
};

export default useScrollToTop;
